"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _error_template = _interopRequireDefault(require("../error_template/error_template"));

var _index = require("../../../material/index");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// error message
// material

/* ========== ~~~~~~~~~~ EXPORT : ERROR : 500 ~~~~~~~~~~ ========== */


var _default = function _default(props) {
  return _react.default.createElement(_error_template.default, {
    styles: 'error500',
    code: "500",
    title: _react.default.createElement("h2", null, "Internal Error Server"),
    bodycopy: _react.default.createElement("p", null, "Don't worry. We are currently looking into the issue. Please try again in few minutes."),
    button: _react.default.createElement(_index.Button, {
      type: "custom",
      handleClick: function handleClick(e) {
        return window.history.back();
      },
      variant: "primary",
      name: "tryagain",
      text: "Try Again"
    }),
    illustration: _react.default.createElement(_index.Illustration, {
      name: "error-500",
      text: "Error Illustration"
    })
  });
};

exports.default = _default;